var _rect, _rect2, _rect3, _circle, _rect4, _rect5, _circle2, _rect6, _rect7, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalancingIconBalanced(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    fill: "white",
    stroke: "#254057"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 20,
    height: 1,
    fill: "#C9CFD5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 11,
    height: 1,
    fill: "#254057"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 11.5,
    r: 2.5,
    fill: "#254057"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 18,
    width: 20,
    height: 1,
    fill: "#C9CFD5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 18,
    width: 11,
    height: 1,
    fill: "#254057"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 2.5,
    fill: "#254057"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 25,
    width: 20,
    height: 1,
    fill: "#C9CFD5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 25,
    width: 11,
    height: 1,
    fill: "#254057"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 25.5,
    r: 2.5,
    fill: "#254057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalancingIconBalanced);
export default __webpack_public_path__ + "static/media/balancingIconBalanced.8336ab51e0e669c6f57a2d00dde35e4e.svg";
export { ForwardRef as ReactComponent };